import type { GridColumns } from './types';

const gridColumns: GridColumns = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 12,
  xl: 12,
};

export { gridColumns };
